// extracted by mini-css-extract-plugin
export var card = "GTwoReviews-module--card--bc1b7";
export var cardDark = "GTwoReviews-module--cardDark--88516";
export var cardLight = "GTwoReviews-module--cardLight--10dd3";
export var column = "GTwoReviews-module--column--82f2e";
export var columnThin = "GTwoReviews-module--columnThin--89d9b";
export var columnWide = "GTwoReviews-module--columnWide--aee64";
export var container = "GTwoReviews-module--container--897b5";